import getAllMeetingTypeExtensions from '../services/getAllMeetingTypeExtensions';
import setMeetingTypeExtensions from '../actions/setMeetingTypeExtensions';
import type MeetingTypeExtensionResponse from '../services/schema/MeetingTypeExtensionResponse';
import { trace } from 'owa-trace';

/**
 * Triggers a service call to get the booking meetingTypeExtensions.
 */
export default async function syncAllMeetingTypeExtensions() {
    try {
        const result = await getAllMeetingTypeExtensions();
        if (result) {
            const meetingTypeExtensionsMap = new Map<string, MeetingTypeExtensionResponse>();

            result.meetingTypeExtensions &&
                result.meetingTypeExtensions.map(
                    (meetingTypeExtension: MeetingTypeExtensionResponse) => {
                        if (meetingTypeExtension.itemId) {
                            meetingTypeExtensionsMap.set(
                                meetingTypeExtension.itemId,
                                meetingTypeExtension
                            );
                        }
                    }
                );
            setMeetingTypeExtensions(meetingTypeExtensionsMap);
        }
    } catch (e) {
        trace.warn(e.message || 'syncAllMeetingTypeExtensions failed');
    }
}
